<zwi-main-wrapper>
  <zwi-main-content>
    <div class="zwi-section">
      <mat-toolbar>
        <div class="zwi-page-title">
          <mat-icon class="zwi-page-title__icon">bookmark</mat-icon>
          <div class="zwi-page-title__text">Saved</div>
        </div>
      </mat-toolbar>
      @if (authService.sessionStatus() !== 2) {
      } @else {
        @if (authService.hasSession() === false) {
          <zwi-sign-in-call-to-action>
            <ng-container title>Sign in to save sermons</ng-container>
            <ng-container content>Once you sign in, you'll be able to save sermons.</ng-container>
          </zwi-sign-in-call-to-action>
        } @else {
          <zwi-favorite-sermons></zwi-favorite-sermons>
        }
      }
    </div>
  </zwi-main-content>
</zwi-main-wrapper>
